import styles from './BusinessCard.module.css';
import Icon from '../../Icon';
import CardIconButton from '../../UI/CardIconButton/CardIconButton';
import { useFavorite } from '../../../pages/FavoritePage/FavoriteContext';
import { useCompare } from '../../../pages/ComparePage/CompareContext';
import { BusinessCardData } from '../types';
import { BUSINESS_CARD_PAGE } from '../../../router/paths';
import { useNavigate } from 'react-router-dom';
import { getDisplayPricePerM2 } from '../../../utils/discountPriceUtils';

interface BusinessCardProps {
  businessData: BusinessCardData;
  isDiscounted: boolean;
}

export default function BusinessCard({ businessData, isDiscounted }: BusinessCardProps) {

  const { favorites, toggleFavorite } = useFavorite();
  const { compares, toggleCompare } = useCompare();
  const navigate = useNavigate();

  const isFavorite = favorites.some(
    (item) => item.id === businessData.id && item.type === 'business'
  );

  const isCompared = compares.some(
    (item) => item.id === businessData.id && item.type === 'business'
  );

  const handleToggleFavorite = () => {
    toggleFavorite({
      ...businessData,
      type: 'business',
      roomType: '',
      entrance: 0,
      imageSecond: '',
      projectType: '',
      totalEntrances: 0,
      totalFloors: 0,
      livingArea: '',
    });
  };

  const handleToggleCompare = () => {
    toggleCompare({
      ...businessData,
      type: 'business',
      roomType: '',
      entrance: 0,
      imageSecond: '',
      projectType: '',
      totalEntrances: 0,
      livingArea: '',
    });
  };

  const handleCardClick = () => {
    navigate(BUSINESS_CARD_PAGE.replace(':id', businessData.id.toString()));
  };

  const getFloorLabel = (floor: number): string => {
    if (floor === 0) return 'Цоколь';
    if (floor === 1 || floor === 2) return `${floor} этаж`;
    return `${floor}`;
  };

  console.log('DEBUG pricePerM2:', businessData.pricePerM2);
  const formatPrice = (value: any) => {
    if (typeof value === 'number' && !isNaN(value)) return value.toLocaleString('ru-RU');
    if (typeof value === 'string') {
      const num = Number(value.replace(/\s+/g, ''));
      return !isNaN(num) && num > 0 ? num.toLocaleString('ru-RU') : '—';
    }
    return '—';
  };
  const formatArea = (value: any) => typeof value === 'number' ? value.toString().replace('.', ',') : (typeof value === 'string' ? value.replace('.', ',') : '—');

  // Вычисляем цену со скидкой, если есть discountProperty
  let discountedPrice = Number(businessData.price);
  const areaNum = Number(businessData.area);
  if (typeof businessData.discountProperty === 'number' && businessData.discountProperty > 0 && !isNaN(areaNum) && !isNaN(discountedPrice)) {
    discountedPrice = Number(businessData.price) - businessData.discountProperty * areaNum;
    if (discountedPrice < 0) discountedPrice = 0;
  }
  const hasDiscount = typeof businessData.discountProperty === 'number' && businessData.discountProperty > 0 && discountedPrice !== Number(businessData.price);

  // Calculate discounted price per m² when there's a discount
  const displayPricePerM2 = getDisplayPricePerM2(businessData.pricePerM2, businessData.discountProperty);

  return (
    <div
      className={styles.wrapper}
      onClick={handleCardClick}
    >
      <div className={styles.info}>
        <div className={styles.top}>
          <div className={styles.room}>
            <div className={styles.room_number}>
              <h4>Помещение</h4>
            </div>
            <div className={styles.room_m2}>
              <h4>
                <span>{formatArea(businessData.area)}</span> м²
              </h4>
            </div>
          </div>
          <div className={styles.buttons}>
            <CardIconButton 
              iconType='icon2' 
              isActive={isFavorite} 
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                handleToggleFavorite();
              }} 
            />
            <CardIconButton 
              iconType='icon3' 
              isActive={isCompared} 
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                handleToggleCompare();
              }} 
            />
          </div>
        </div>
        <div className={styles.additional_info}>
          <div>
            <p className='text_body_b3'>
              <span>{getFloorLabel(businessData.floor)}</span>
            </p>
          </div>
        </div>
      </div>
      <div className={styles.image}>
        <img src={businessData.image} alt='Изображение квартиры'/>
      </div>
      <div className={styles.price_block}>
        {hasDiscount && (
          <div className={styles.discount}>
            <div className={styles.discount_icon}>
              <Icon name='hotSale' width='13' height='16' />
            </div>
            <div className={styles.discount_title}>
              <p className='text_subheaders_sh3'>Выгодное предложение</p>
            </div>
          </div>
        )}
        <div className={styles.price_group}>
          <div className={styles.price_m2}>
            <p className='text_body_b3'>
              от <span>{displayPricePerM2}</span> ₽ за м²
            </p>
          </div>
          <div className={styles.price_area}>
            <div className={styles.price}>
              <h4>
                от <span>{formatPrice(discountedPrice)}</span> ₽
              </h4>
            </div>
            {hasDiscount && businessData.price && (
              <div className={styles.price_no_discount}>
                <p className='text_body_b2'>
                  от <span>{formatPrice(businessData.price)}</span> ₽
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
